import type { Transition } from "motion/react";
import { cssVar } from "./cssVar";

// ── Spring Presets ──────────────────────────────────────
// All use Motion's stiffness/damping/mass model.
// Adjust values here — every animated component reads from this file.

export const springs = {
  /** Hover lift/tilt, general interactions */
  snappy: { type: "spring", stiffness: 300, damping: 20, mass: 0.8 } as Transition,
  /** Tap press-down — high damping = no overshoot */
  press: { type: "spring", stiffness: 400, damping: 35, mass: 0.8 } as Transition,
  /** Tap release — low damping = slight overshoot */
  bounce: { type: "spring", stiffness: 300, damping: 15 } as Transition,
  /** Sliding active indicator */
  indicator: { type: "spring", stiffness: 500, damping: 30 } as Transition,
  /** Entrance stagger, ambient motion */
  gentle: { type: "spring", stiffness: 200, damping: 20 } as Transition,
} as const;

// ── Animation Tokens ───────────────────────────────────
// Numeric values consumed by components. Tweak here, see everywhere.

export const tokens = {
  hoverLift: -2,          // translateY pixels
  hoverTilt: 2,           // rotate degrees (icon only)
  pressScale: 0.88,       // scale on tap-down
  drawDuration: 0.6,      // SVG pathLength draw seconds
  staggerDelay: 0.08,     // entrance stagger between items
  entranceY: 12,          // entrance translateY start offset
} as const;

// ── Theme Colors (from Tailwind config) ────────────────
// Read from CSS custom properties at runtime. Functions evaluate lazily
// per render, which is fine for motion props and template literals.

export const motionColors = {
  inactive: () => cssVar('--color-text-muted'),
  hover: () => cssVar('--color-astral-violet'),
  active: () => cssVar('--color-gold'),
  // theme-audit: JS literal — framer-motion interpolates these filter strings; color-mix()/var() break its numeric color animation, so gold rgba kept
  hoverGlow: "drop-shadow(0 0 8px rgba(122, 154, 181, 0.35))",
  activeGlow: "drop-shadow(0 0 6px rgba(122, 154, 181, 0.4))",
  activeGlowDim: "drop-shadow(0 0 6px rgba(122, 154, 181, 0.25))",
  indicatorFrom: () => cssVar('--color-astral-violet'),
  indicatorTo: () => cssVar('--color-gold'),
} as const;
